export const FIELD_TYPES = [
  {
    text: 'Number',
    value: 'int',
  },
  {
    text: 'True/False',
    value: 'bool',
  },
  {
    text: 'Text',
    value: 'string',
  },
  {
    text: 'Textarea',
    value: 'textarea',
  },
  {
    text: 'Email',
    value: 'email',
  },
  {
    text: 'Date',
    value: 'date',
  },
  {
    text: 'Time',
    value: 'time',
  },
  {
    text: 'List',
    value: 'list',
  },
  {
    text: 'Related Contacts',
    value: 'related_contacts',
  },
  {
    text: 'Image',
    value: 'image',
  },
  {
    text: 'ID Number',
    value: 'id_number',
  },
  {
    text: 'Secret',
    value: 'secret',
  },
  {
    text: 'Related Custom Object',
    value: 'related_custom_object',
  },
  {
    text: 'User List',
    value: 'user_list',
  },
];

import { ROLES as USER_ROLES } from '@/access/roles';

export const ROLES = [
  { text: 'Admins Only', value: USER_ROLES.ADMIN },
  { text: 'Admins & Guests', value: USER_ROLES.GUEST },
];

export const SHARE_EDITABLE = [
  { text: 'No', value: '0' },
  { text: 'Yes', value: '1' },
];

export const FIELD_CONVERSION_MAP = {
  int: ['string', 'secret'],
  bool: ['int', 'string'],
  string: ['int', 'textarea', 'email', 'secret'],
  textarea: ['string'],
  email: ['string'],
  date: ['string', 'time', 'int'],
  time: ['string', 'date', 'int'],
  image: [],
  list: [],
  related_contacts: [],
  related_custom_object: [],
  secret: [],
  id_number: [],
  user_list: [],
};

export const FIELD_TYPE_MAP = {
  bool: 'Checkbox',
  date: 'Date',
  image: 'Image',
  id_number: 'Number',
  int: 'Number',
  list: 'ContactList',
  related_contacts: 'ContactList',
  relation: 'ContactList',
  related_custom_object: 'RelatedCustomObject',
  string: 'Text',
  email: 'Text',
  textarea: 'TextArea',
  time: 'DateTime',
  secret: 'Secret',
  user_list: 'UserList',
};

// Optional Material Symbols icon shown next to the field label on the contact profile.
// A stored `icon` overrides the type/name default from getDefaultFieldIcon().
export const FIELD_ICON_SCHEMA = Object.freeze({
  label: 'Icon',
  clearable: true,
  placeholder: 'Default',
});

// Notion-style default property icons by field type (Notion → Material Symbols):
// Text ≡ → short_text, Number # → tag, Checkbox → check_box, Date → calendar_today,
// Email @ → alternate_email, Multi-select → format_list_bulleted, Person → person,
// Relation → link, Files & media → image.
export const FIELD_TYPE_DEFAULT_ICONS = Object.freeze({
  string: 'short_text',
  textarea: 'notes',
  int: 'tag',
  id_number: 'tag',
  bool: 'check_box',
  date: 'calendar_today',
  time: 'schedule',
  email: 'alternate_email',
  list: 'format_list_bulleted',
  image: 'image',
  secret: 'lock',
  related_contacts: 'person',
  relation: 'link',
  related_custom_object: 'link',
  user_list: 'group',
});

// A string/int field with a dropdown values list behaves like a Notion Select.
export const FIELD_SELECT_DEFAULT_ICON = 'arrow_drop_down_circle';

// Well-known default-bucket fields whose name says more than their type.
export const FIELD_NAME_DEFAULT_ICONS = Object.freeze({
  first_name: 'person',
  last_name: 'person',
  mobile: 'phone',
  tags: 'sell',
  timezone: 'public',
});

export const getDefaultFieldIcon = (field) => {
  if (!field) return '';

  const byName = FIELD_NAME_DEFAULT_ICONS[field.name];
  if (byName) return byName;

  // The fields API always ships `values`; the contact payload only ships
  // `values_enabled`, which is true there only when a values list exists.
  const hasValues = Array.isArray(field.values)
    ? field.values.length > 0
    : !!field.values_enabled;
  if (hasValues) {
    return FIELD_SELECT_DEFAULT_ICON;
  }

  return FIELD_TYPE_DEFAULT_ICONS[field.type] || '';
};

// The field dialogs edit dropdown values as one-per-line text.
export const valuesTextToList = (values) => {
  if (Array.isArray(values)) return values;
  return String(values || '')
    .split('\n')
    .map((v) => v.trim())
    .filter(Boolean);
};

// Icon to display for a field: the user's override when set, otherwise the default.
export const resolveFieldIcon = (field) => {
  if (!field) return '';
  return field.icon || getDefaultFieldIcon(field);
};

export const getFieldTypeLabel = (type) => {
  const fieldType = FIELD_TYPES.find((field) => field.value === type);
  return fieldType ? fieldType.text : 'Unknown';
};
